import React from 'react';
import { Trans } from 'i18n';
import DocumentLink from 'components/common/DocumentLink';

export type AgreementProps = Omit<React.ComponentProps<typeof Trans>, 'i18nKey' | 'ns'>;

const Agreement: React.FC<React.PropsWithChildren<AgreementProps>> = (props) => (
  <Trans i18nKey="statement.agreement" ns="common" {...props}>
    <DocumentLink document="privacy" />
    <DocumentLink document="terms" />
  </Trans>
);

export default Agreement;
